<template>
  <div class="Interface">
    <table class="layui-table" style="text-align: center">
      <thead>
        <tr>
          <th v-for="(item , index ) in colData" :key="index" style="text-align:center"> {{ item }} </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item , index ) in rowData" :key="index">
          <td style="text-align:center"> {{ item.name }} </td>
          <td style="text-align:center"> {{ item.allMoney }} </td>
          <td style="text-align:center"> {{ item.count}} </td>
          <td style="text-align:center"> {{ item.sum }} </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "Interface",
  data() {
    return {
      colData: [],
      rowData: [],
    };
  },
  created() {
    this.$axios
      .get("http://big1.lcyjfz.com/lcyj/public/card/e6f93a02-084d-4b68-9116-670b93e179af/query?parameters=%5B%5D")
      .then((res) => {
        this.colData = res.data.data.cols.map((item) => item.display_name);
        this.rowData = res.data.data.rows.map((item) => {
          let obj = {};
          obj.name = item[0]; // 名字
          obj.allMoney = item[1]; //总价
          obj.count = item[2]; // 数量
          obj.sum = item[3]; // 总和
          return obj;
        });
      });
  },
};
</script>

<style>
</style>